export default "__VITE_ASSET__DxXyxt$1__"